import React, {useContext, useMemo, useState,} from 'react'
import {useRouteSearchParam} from "../../../envs/_current/history";
import {PiUserCirclePlusLight, PiUserFocusLight, PiUsersThreeLight} from "react-icons/pi";
import useTranslate from "../../../modules/local/useTranslate";
import {getId} from "../../../apis/model/base";
import {LayoutContext} from "../../../components/layouts/Default/LayoutContext";
import {useRouterSearchParam} from "modules/navigation/useOnLocationChange";
import {branch, compose, fromRenderProps, nest, pure, renderNothing} from "recompose";
import WorkspaceContext from "../WorkspaceContext";
import UseState from "../../../components/UseState";
import Members from "../../MemberSetting/Members.lazy";
import {GoverningOrganizationList} from "../Host/WorkspaceGoverningOrganizations";
import WaitingAcceptMembers from "../../MemberSetting/WaitingAcceptMembers.lazy";
import InviteManager from "../../Organization/Settings/InviteManager";
import classNames from "classnames";
import {SectionTemplate} from "../Workspace";
import {useMemberForm} from "../../MemberSetting/useMemberForm";

// --- Cấu trúc Menu Cấp 2 (Chi tiết Khóa học) ---
const ORG_MEMBER_TABS = [
    {key: 'members', name: 'members', icon: <PiUsersThreeLight size={18}/>},
    {key: 'registers', name: 'registers', icon: <PiUserFocusLight size={18}/>},
    {key: 'invites', name: 'invites', icon: <PiUserCirclePlusLight size={18}/>},
];


// --- Component Tab điều hướng (Dùng chung cho Cấp 2 & Cấp 3) ---
const TabNavigation = ({tabs, activeTab, onTabChange}) => {
    const t = useTranslate();

    return (
        <div
            className="mt-3 flex gap-1 overflow-x-auto background-100 rounded-t-xl border-b border-color-50 stickyTop1">
            {tabs.map((tab) => (
                <button
                    key={tab.key}
                    onClick={() => onTabChange(tab.key)}
                    className={classNames(
                        `p-3 flex flex-center flex-shrink-0 gap-2 text-sm font-medium transition-colors border-b-2`,
                        activeTab === tab.key
                            ? 'border-indigo-500 text-indigo-600'
                            : 'border-transparent text-color-200 hover:text-indigo-500 hover:border-indigo-300'
                    )}>
                    {tab?.icon}
                    <span className="hidden lg:block">{t(tab.name)}</span>
                    <span className="lg:hidden">{t(tab.name)}</span>
                </button>
            ))}
        </div>
    );
}


const WorkspaceMembersList = compose(
    fromRenderProps(WorkspaceContext.Consumer, ({organization}) => ({
        container: organization,
    })),
    branch(({container}) => !!!getId(container), renderNothing),
    pure
)(
    nest(
        ({container, action, setAction, children}) => {

            return (
                <UseState initialValue={{type: undefined, value: undefined}}>
                    {([action, setAction]) => (
                        <Members
                            {...{action, setAction}}
                            item={container}>
                        </Members>
                    )}
                </UseState>
            )
        },
        GoverningOrganizationList
    )
)

const WorkspaceMembersWaitingList = compose(
    fromRenderProps(WorkspaceContext.Consumer, ({organization}) => ({
        container: organization,
    })),
    branch(({container}) => !!!getId(container), renderNothing),
    pure
)(
    nest(
        ({container, children}) => (
            <WaitingAcceptMembers
                item={container}>
            </WaitingAcceptMembers>
        ),
        GoverningOrganizationList
    )
)

const WorkspaceMembersInvites = compose(
    fromRenderProps(WorkspaceContext.Consumer, ({organization}) => ({
        container: organization,
    })),
    branch(({container}) => !!!getId(container), renderNothing),
    pure
)(
    nest(
        ({container, children}) => (
            <InviteManager
                item={container}>
            </InviteManager>
        ),
        GoverningOrganizationList
    )
)

const WorkspaceOrganizationMemberDetail = ({}) => {
    const t = useTranslate();
    const orgMemberDetailTab = useRouteSearchParam("org-member-tab") || "members"
    const [activeTab, setActiveTab] = useState(orgMemberDetailTab);
    const {isSm, isLg} = useContext(LayoutContext)
    const {organization} = useContext(WorkspaceContext)

    const {
        modal,
        handleAction,
        refreshKey
    } = useMemberForm({owner: organization})


    const {onChangeSearchParams} = useRouterSearchParam({})

    // Render nội dung cụ thể cho từng tab Cấp 2
    const renderOrgMemberContent = useMemo(() => {
            switch (activeTab) {
                case 'members':
                    return (
                        <div className="flex flex-col gap-4">
                            <h3 className="font-bold text-base text-gray-700 tracking-wide uppercase">
                                {t("list of members")}
                            </h3>
                            {/*<Button*/}
                            {/*    type="primary"*/}
                            {/*    className="mt-6 px-6 py-2 bg-indigo-500 text-white rounded-lg shadow-md hover:bg-indigo-600 transition"*/}
                            {/*    onClick={() => {*/}
                            {/*        handleAction({type: CRUD.CREATE, action: organization})*/}
                            {/*    }}>*/}
                            {/*    {t("add member")}*/}
                            {/*</Button>*/}
                            <WorkspaceMembersList/>
                        </div>
                    );
                case 'registers':
                    return (
                        <div className="flex flex-col gap-4">
                            <h3 className="font-bold text-base text-gray-700 tracking-wide uppercase">
                                {t("registers")}
                            </h3>
                            <WorkspaceMembersWaitingList/>
                        </div>
                    );
                case 'invites':
                    return (
                        <div className="flex flex-col gap-4">
                            <h3 className="font-bold text-base text-gray-700 tracking-wide uppercase">
                                {t("invites")}
                            </h3>
                            <WorkspaceMembersInvites/>
                        </div>
                    );

                default:
                    return null;
            }
        },
        [activeTab]);

    return (
        <div className="min-h-screen w-full">
            <SectionTemplate
                title={t("members")}
                description={t("workspace member title description")}
                actionText={t("add member")}
            />

            <TabNavigation tabs={ORG_MEMBER_TABS} activeTab={activeTab} onTabChange={(value) => {
                onChangeSearchParams({"org-member-tab": value})
                setActiveTab(value)
            }}/>

            <div className="p-6 background rounded-b-xl shadow-lg">
                {renderOrgMemberContent}
            </div>

            {modal}
        </div>
    );
};


export default WorkspaceOrganizationMemberDetail
